import React from 'react';
import { useTranslation } from 'react-i18next';
const { m } = require('framer-motion');
import PropTypes from 'prop-types';
import { Stack, Typography, Box, Link } from '@mui/material';
import ResumeInfo from '../../components/ResumeInfo';
const GOOGLE_MAPS_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY;

function EventPlace({
  event: {
    location: { latitude, longitude, venue, address },
  },
  variant = false,
}) {
  const { t } = useTranslation();
  return (
    <>
      {venue !== 'Online' && (
        <>
          <Box
            sx={{
              width: '100%',
              height: !variant ? '200px' : '280px',
              overflow: 'hidden',
              borderRadius: '16px',
            }}
          >
            <iframe
              title="Event Location"
              src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_KEY}&q=${latitude},${longitude}&zoom=14`}
              width="100%"
              height={!variant ? '200px' : '280px'}
              frameBorder="0"
              allowFullScreen
            />
          </Box>
          {!variant  && (
            <>
              <Box
                sx={{
                  paddingTop: '16px',
                  paddingBottom: '10px',
                }}
              >
                <Typography variant="h6">{venue}</Typography>
              </Box>
              <ResumeInfo
                subtitle={address}
                link={t('checkout.global.viewLocation')}
                url={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_KEY}&q=${latitude},${longitude}`}
                iconify="ic:baseline-place"
                sx={{ '& svg': { marginTop: '4px' } }}
              />
            </>
          )}
        </>
      )}
      {venue === 'Online' && (
        <Box
          sx={{
            paddingTop: '16px',
            paddingBottom: '10px',
          }}
        >
          <Typography variant="Body1">{t('checkout.global.eventOnline')}</Typography>
        </Box>
      )}
    </>
  );
}

EventPlace.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventPlace;
